<div class="card">
    <div class="row">
      <div class="col-lg-12">
        <div class="card border-0 shadow-none">
          <div class="card-body">
            <div class="row d-flex">
                <div class="form-group col-md-12 ">
                    <label class="col-form-label" for="categoryName">Remark <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <textarea type="text" id="categoryName" [readonly]="!permissions.includes('Search')" autocomplete="off" class="form-control" required [(ngModel)]="remark" placeholder="Please Enter Remark"></textarea>
                    <div class="invalid-feedback">
                      Category is required
                      </div>
                </div>
            </div>
            <div class="row d-flex" *ngIf="permissions.includes('Search')">
                <div class="form-group col-md-12 text-right">
                    <button class="btn btn-primary" type="button" (click)="saveRemark()">Save</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>   
    <div class="row" style="min-height: 300px">
        <div class="col-12 col-xl-12 stretch-card ag-theme-alpine">
            <ag-grid-angular [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [rowData]="remarkList"
                [paginationPageSize]="pageSize" [pagination]="true" [suppressPaginationPanel]="true"
                [rowSelection]="'single'" class="ag-theme-alpine" style="width: 100%; height: auto;">
            </ag-grid-angular>
        </div>
    </div>
</div>